import addRoute from '@/router/add-route';

const CustomFields = () => import('@/modules/custom-fields/custom-fields.vue');
const CustomFieldForm = () => import('@/modules/custom-fields/custom-field-form.vue');

const customFields = [
    addRoute({
        name: 'custom-fields',
        path: '/custom-fields/:resource?',
        component: CustomFields,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-custom-field',
        path: '/custom-fields/add/:resource?/:continue?',
        component: CustomFieldForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-custom-field',
        path: '/custom-fields/update/:resource/:name',
        component: CustomFieldForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default customFields;
